module.exports = __webpack_public_path__ + "static/img/add.8ac22d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.png
// module id = Zarb
// module chunks = 1